exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-container[data-v-6d306da3] {\n    max-height: 50vh;\n    overflow: auto;\n}\n.table-font-size[data-v-6d306da3] {\n    font-size: .85rem;\n}\n.sections[data-v-6d306da3] {\n    white-space: nowrap;\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n}\n.legend-sm[data-v-6d306da3] {\n    font-size: 1em;\n    font-weight: bold;\n}    \n", ""]);

// exports
